import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDR } from 'tdr-common';
import { useEventsByRestaurant } from '../../api/getEventsByRestaurant';
import { filterEventsForSearchFilters } from '../../helpers/inventory-event-filtering/filterEventsForSearchFilters';
import { EventCardsSkeleton } from './EventCardsSkeleton';
import { InventoryEventCard } from './InventoryEventCard';

type InventorySpecialEventsSectionProps = {
	restaurant: TDR.Restaurant;
};

export function InventorySpecialEventsSection({ restaurant }: InventorySpecialEventsSectionProps) {
	const { t } = useTranslation();
	const { data: events, isLoading: loadingEvents } = useEventsByRestaurant(restaurant.id);
	const visibleEvents = filterEventsForSearchFilters(events ?? []);

	if (!loadingEvents && visibleEvents.length === 0) {
		return null;
	}

	return (
		<section className="px-5 pt-6 pb-2 sm:px-0 sm:pt-8">
			<h2 className="font-poppins text-tablz-text-gray-2 text-lg font-medium mb-3">
				{t('titles.featured_special_events')}
			</h2>
			<div className="list-none m-0 grid grid-cols-1 xl:grid-cols-2 gap-4 py-6 place-items-center w-full sm:py-0 h-fit">
				{loadingEvents ? (
					<EventCardsSkeleton />
				) : (
					visibleEvents.map((event) => (
						<InventoryEventCard key={event.id} event={event} />
					))
				)}
			</div>
		</section>
	);
}
